import { useState, useEffect, useRef } from 'react';

/* ── Theme ── */
const P = {
    purple: '#7C3AED',
    purpleDark: '#6D28D9',
    purpleDeep: '#5B21B6',
    purpleLight: '#EDE9FE',
    purpleMid: '#8B5CF6',
    bg: '#F5F3FF',
    surface: '#FFFFFF',
    border: '#DDD6FE',
    borderLight: '#EDE9FE',
    text: '#1E1B4B',
    textLight: '#6B7280',
    muted: '#9CA3AF',
    success: '#22C55E',
    warning: '#F59E0B',
    danger: '#EF4444'
};

/* ── App Settings JSON (from API) ── */
const APP_SETTINGS = {
    count: 71,
    Details: [
        { app_setting_id: '7105', setting_name: 'BILL_HOLD_OPTION', setting_access: '1', setting_type: 'General', setting_title: 'BILL_HOLD_OPTION', status: 'Active', branch: '49' },
        { app_setting_id: '7112', setting_name: 'SMS_OPTIONS', setting_access: '0', setting_type: 'SMS_OPTIONS', setting_title: 'SMS_OPTIONS', status: 'Active', branch: '49' },
        { app_setting_id: '7121', setting_name: 'BILL_EDIT_BUTTON', setting_access: '0', setting_type: 'General', setting_title: 'BILL_EDIT_BUTTON', status: 'Active', branch: '49' },
        { app_setting_id: '7122', setting_name: 'SOCIAL_ORDER_BUTTON', setting_access: '0', setting_type: 'General', setting_title: 'SOCIAL_ORDER_BUTTON', status: 'Active', branch: '49' },
        { app_setting_id: '7123', setting_name: 'ADVANCE_ORDER_MODULE_BUTTON', setting_access: '1', setting_type: 'General', setting_title: 'ADVANCE_ORDER_MODULE_BUTTON', status: 'Active', branch: '49' },
        { app_setting_id: '7124', setting_name: 'SANTHE_MODULE_BUTTON', setting_access: '0', setting_type: 'General', setting_title: 'SANTHE_MODULE_BUTTON', status: 'Active', branch: '49' },
        { app_setting_id: '7125', setting_name: 'DISCOUNT_BUTTON', setting_access: '0', setting_type: 'General', setting_title: 'DISCOUNT_BUTTON', status: 'Active', branch: '49' },
        { app_setting_id: '7126', setting_name: 'CASH', setting_access: '1', setting_type: 'Payment', setting_title: 'CASH', status: 'Active', branch: '49' },
        { app_setting_id: '7127', setting_name: 'CARD', setting_access: '1', setting_type: 'Payment', setting_title: 'CARD', status: 'Active', branch: '49' },
        { app_setting_id: '7128', setting_name: 'NC', setting_access: '1', setting_type: 'Payment', setting_title: 'NC', status: 'Active', branch: '49' },
        { app_setting_id: '7129', setting_name: 'MULTI', setting_access: '1', setting_type: 'Payment', setting_title: 'MULTI', status: 'Active', branch: '49' },
        { app_setting_id: '7130', setting_name: 'PAYTM', setting_access: '1', setting_type: 'Payment', setting_title: 'PAYTM', status: 'Active', branch: '49' },
        { app_setting_id: '7131', setting_name: 'SWIGGY', setting_access: '1', setting_type: 'Other_Payment', setting_title: 'SWIGGY', status: 'Active', branch: '49' },
        { app_setting_id: '7132', setting_name: 'ZOMATO', setting_access: '1', setting_type: 'Other_Payment', setting_title: 'ZOMATO', status: 'Active', branch: '49' },
        { app_setting_id: '7133', setting_name: 'SWIGGYSTORE', setting_access: '0', setting_type: 'Other_Payment', setting_title: 'SWIGGYSTORE', status: 'Active', branch: '49' },
        { app_setting_id: '7134', setting_name: 'URBAN', setting_access: '0', setting_type: 'Other_Payment', setting_title: 'URBAN', status: 'Active', branch: '49' },
        { app_setting_id: '7135', setting_name: 'DUNZO', setting_access: '0', setting_type: 'Other_Payment', setting_title: 'DUNZO', status: 'Active', branch: '49' },
        { app_setting_id: '7136', setting_name: 'DEFAULT_DISCOUNT', setting_access: '1', setting_type: 'Discount', setting_title: 'DEFAULT_DISCOUNT', status: 'Active', branch: '49' },
        { app_setting_id: '7137', setting_name: 'CATEGORY_WISE_DISCOUNT', setting_access: '0', setting_type: 'Discount', setting_title: 'CATEGORY_WISE_DISCOUNT', status: 'Active', branch: '49' },
        { app_setting_id: '7138', setting_name: 'FLAT_DISCOUNT', setting_access: '1', setting_type: 'Discount', setting_title: 'FLAT_DISCOUNT', status: 'Active', branch: '49' },
        { app_setting_id: '7139', setting_name: 'PHONEPE', setting_access: '0', setting_type: 'Payment', setting_title: 'PHONEPE', status: 'Active', branch: '49' },
        { app_setting_id: '7140', setting_name: 'TOKEN', setting_access: '0', setting_type: 'General', setting_title: 'TOKEN', status: 'Active', branch: '49' },
        { app_setting_id: '7141', setting_name: 'LOGOUT_SMS_TRIGGER', setting_access: '0', setting_type: 'General', setting_title: 'LOGOUT_SMS_TRIGGER', status: 'Active', branch: '49' },
        { app_setting_id: '7142', setting_name: 'CUSTOMER_DETAILS_COLLECTION', setting_access: '0', setting_type: 'General', setting_title: 'CUSTOMER_DETAILS_COLLECTION', status: 'Active', branch: '49' },
        { app_setting_id: '7143', setting_name: 'DAYCLOSE_SMS_TYPE', setting_access: '2', setting_type: 'General', setting_title: 'DAYCLOSE_SMS_TYPE', status: 'Active', branch: '49' },
        { app_setting_id: '7144', setting_name: 'RECORD_DELETE_TYPE', setting_access: '1', setting_type: 'General', setting_title: 'RECORD_DELETE_TYPE', status: 'Active', branch: '49' },
        { app_setting_id: '7145', setting_name: 'NC_MODULE_POPUP', setting_access: '0', setting_type: 'General', setting_title: 'NC_MODULE_POPUP', status: 'Active', branch: '49' },
        { app_setting_id: '7146', setting_name: 'CATEGORY_SECTION_DISPLAY', setting_access: '1', setting_type: 'General', setting_title: 'CATEGORY_SECTION_DISPLAY', status: 'Active', branch: '49' },
        { app_setting_id: '7147', setting_name: 'SUPPLIER_OR_CASHIER_NO_INPUT', setting_access: '0', setting_type: 'General', setting_title: 'SUPPLIER_OR_CASHIER_NO_INPUT', status: 'Active', branch: '49' },
        { app_setting_id: '7148', setting_name: 'SOCIAL_ORDER_RECIPT_PRINT', setting_access: '0', setting_type: 'General', setting_title: 'SOCIAL_ORDER_RECIPT_PRINT', status: 'Active', branch: '49' },
        { app_setting_id: '7149', setting_name: 'TOKEN_COUNT', setting_access: '0', setting_type: 'General', setting_title: 'TOKEN_COUNT', status: 'Active', branch: '49' },
        { app_setting_id: '7150', setting_name: 'HSN_DISPLAY_OPTION', setting_access: '1', setting_type: 'General', setting_title: 'HSN_DISPLAY_OPTION', status: 'Active', branch: '49' },
        { app_setting_id: '7151', setting_name: 'SUPPLIER_OR_CASHIER_NO_DISPLAY', setting_access: '0', setting_type: 'General', setting_title: 'SUPPLIER_OR_CASHIER_NO_DISPLAY', status: 'Active', branch: '49' },
        { app_setting_id: '7152', setting_name: 'CREDIT_ORDER_MODULE', setting_access: '0', setting_type: 'General', setting_title: 'CREDIT_ORDER_MODULE', status: 'Active', branch: '49' },
        { app_setting_id: '7153', setting_name: 'COMBO_ORDER_MODULE', setting_access: '0', setting_type: 'General', setting_title: 'COMBO_ORDER_MODULE', status: 'Active', branch: '49' },
        { app_setting_id: '7154', setting_name: 'PRODUCT_IMAGE_DISPALY', setting_access: '0', setting_type: 'General', setting_title: 'PRODUCT_IMAGE_DISPALY', status: 'Active', branch: '49' },
        { app_setting_id: '7155', setting_name: 'HSN_OR_SAC_DISPLAY_OPTION', setting_access: '1', setting_type: 'General', setting_title: 'HSN_OR_SAC_DISPLAY_OPTION', status: 'Active', branch: '49' },
        { app_setting_id: '7156', setting_name: 'PRIMARY_SYSTEM', setting_access: '1', setting_type: 'General', setting_title: 'POS1', status: 'Active', branch: '49' },
        { app_setting_id: '7157', setting_name: 'ADVANCE_ORDER_AND_INVOICE_FORMAT', setting_access: '0', setting_type: 'General', setting_title: 'ADVANCE_ORDER_AND_INVOICE_FORMAT', status: 'Active', branch: '49' },
        { app_setting_id: '7158', setting_name: 'PRODUCT_DISP_DEFAULT/TOPSALES', setting_access: '0', setting_type: 'General', setting_title: 'PRODUCT_DISP_DEFAULT/TOPSALES', status: 'Active', branch: '49' },
        { app_setting_id: '7159', setting_name: 'NEFT', setting_access: '0', setting_type: 'APayment', setting_title: 'NEFT', status: 'Active', branch: '49' },
        { app_setting_id: '7160', setting_name: 'CHEQUE', setting_access: '0', setting_type: 'APayment', setting_title: 'CHEQUE', status: 'Active', branch: '49' },
        { app_setting_id: '7161', setting_name: 'DOTPE', setting_access: '0', setting_type: 'Payment', setting_title: 'DOTPE', status: 'Active', branch: '49' },
        { app_setting_id: '7162', setting_name: 'AMAZON', setting_access: '0', setting_type: 'Other_Payment', setting_title: 'AMAZON', status: 'Active', branch: '49' },
        { app_setting_id: '7163', setting_name: 'TOKEN_TYPE', setting_access: '0', setting_type: 'General', setting_title: 'TOKEN_TYPE', status: 'Active', branch: '49' },
        { app_setting_id: '7164', setting_name: 'RECEIPT_ROUNDOFF_DISPLAY', setting_access: '0', setting_type: 'General', setting_title: 'RECEIPT_ROUNDOFF_DISPLAY', status: 'Active', branch: '49' },
        { app_setting_id: '7165', setting_name: 'CAFE', setting_access: '0', setting_type: 'Payment', setting_title: 'CAFE', status: 'Active', branch: '49' },
        { app_setting_id: '7166', setting_name: 'OPERATION_MODE', setting_access: '0', setting_type: 'OPERATION_MODE', setting_title: 'OPERATION_MODE', status: 'Active', branch: '49' },
        { app_setting_id: '7167', setting_name: 'ITEMWISE_REPORT', setting_access: '0', setting_type: 'General', setting_title: 'ITEMWISE_REPORT', status: 'Active', branch: '49' },
        { app_setting_id: '7168', setting_name: 'SMS_OPTIONS', setting_access: '2', setting_type: 'SMS_OPTIONS', setting_title: 'SMS_OPTIONS', status: 'Active', branch: '49' },
        { app_setting_id: '7169', setting_name: 'DENOMINATION_ENTRY', setting_access: '0', setting_type: 'DENOMINATION_ENTRY', setting_title: 'DENOMINATION_ENTRY', status: 'Active', branch: '49' },
        { app_setting_id: '7170', setting_name: 'VOUCHER_ENTRY', setting_access: '0', setting_type: 'VOUCHER_ENTRY', setting_title: 'VOUCHER_ENTRY', status: 'Active', branch: '49' },
        { app_setting_id: '7171', setting_name: 'BILL_CANCELLATION', setting_access: '0', setting_type: 'BILL_CANCELLATION', setting_title: 'BILL_CANCELLATION', status: 'Active', branch: '49' },
        { app_setting_id: '7172', setting_name: 'DATA_EXPORT', setting_access: '0', setting_type: 'DATA_EXPORT', setting_title: 'DATA_EXPORT', status: 'Active', branch: '49' },
        { app_setting_id: '7173', setting_name: 'LOCAL_DATA_BACKUP_DAYEND', setting_access: '0', setting_type: 'General', setting_title: 'LOCAL_DATA_BACKUP_DAYEND', status: 'Active', branch: '49' },
        { app_setting_id: '7174', setting_name: 'CLIENT_API_LINK', setting_access: '1', setting_type: 'https://sreenivasabrahminsbakery.in/Counter-Backend/index.php/Client_data/', setting_title: 'CLIENT_API_LINK', status: 'Active', branch: '49' },
        { app_setting_id: '7175', setting_name: 'SERVER_API_LINK', setting_access: '1', setting_type: 'https://gsonlinesolutions.com/SalesMaster/index.php/Live_data/', setting_title: 'SERVER_API_LINK', status: 'Active', branch: '49' },
        { app_setting_id: '7176', setting_name: 'INVOICE_NUM_CREATION', setting_access: '0', setting_type: 'General', setting_title: 'INVOICE_NUM_CREATION', status: 'Inactive', branch: '49' },
        { app_setting_id: '7178', setting_name: 'COUNTER_INVOICE_FORMAT', setting_access: '1', setting_type: 'GENERAL', setting_title: 'COUNTER_INVOICE_FORMAT', status: 'Active', branch: '49' },
        { app_setting_id: '7180', setting_name: 'CASH_CALCULATOR', setting_access: '0', setting_type: 'General', setting_title: 'CASH_CALCULATOR', status: 'Inactive', branch: '49' },
        { app_setting_id: '7182', setting_name: 'CREDIT', setting_access: '0', setting_type: 'Payment', setting_title: 'CREDIT', status: 'Inactive', branch: '49' },
        { app_setting_id: '7184', setting_name: 'LIVE_SYNCH_TIMEOUT', setting_access: '1', setting_type: '10000', setting_title: 'LIVE_SYNCH_TIMEOUT', status: 'Active', branch: '49' },
        { app_setting_id: '7186', setting_name: 'LIVE_SYNCH_BATCH_SIZE', setting_access: '1', setting_type: '25', setting_title: 'LIVE_SYNCH_BATCH_SIZE', status: 'Active', branch: '49' },
        { app_setting_id: '7188', setting_name: 'DAY_CLOSE_SYNCH_TIMEOUT', setting_access: '1', setting_type: '45000', setting_title: 'DAY_CLOSE_SYNCH_TIMEOUT', status: 'Active', branch: '49' },
        { app_setting_id: '7190', setting_name: 'DAY_CLOSE_SYNCH_BATCH_SIZE', setting_access: '1', setting_type: '50', setting_title: 'DAY_CLOSE_SYNCH_BATCH_SIZE', status: 'Active', branch: '49' },
        { app_setting_id: '7192', setting_name: 'WRITE_TO_BACKUP', setting_access: '0', setting_type: 'General', setting_title: 'WRITE_TO_BACKUP', status: 'Active', branch: '49' },
        { app_setting_id: '7194', setting_name: 'BILLING_OFFERS', setting_access: '0', setting_type: 'General', setting_title: 'BILLING_OFFERS', status: 'Inactive', branch: '49' },
        { app_setting_id: '7196', setting_name: 'GIFT', setting_access: '0', setting_type: 'GIFT', setting_title: 'Payment', status: 'Inactive', branch: '49' },
        { app_setting_id: '7198', setting_name: 'API_TIMEOUT', setting_access: '1', setting_type: '15000', setting_title: 'API_TIMEOUT', status: 'Active', branch: '49' },
        { app_setting_id: '9047', setting_name: 'VOUCHER', setting_access: '0', setting_type: 'Payment', setting_title: 'VOUCHER', status: 'Inactive', branch: '49' },
        { app_setting_id: '10817', setting_name: 'OWNLY', setting_access: '0', setting_type: 'Payment', setting_title: 'OWNLY', status: 'Inactive', branch: '49' }
    ]
};

/* ── Color map for all possible payment methods ── */
const PAY_COLOR_MAP = {
    CASH: { color: '#22C55E', dark: '#15803D' },
    CARD: { color: '#3B82F6', dark: '#1D4ED8' },
    NC: { color: '#8B5CF6', dark: '#6D28D9' },
    MULTI: { color: '#F59E0B', dark: '#B45309' },
    PAYTM: { color: '#06B6D4', dark: '#0E7490' },
    PHONEPE: { color: '#6D28D9', dark: '#4C1D95' },
    DOTPE: { color: '#0EA5E9', dark: '#0369A1' },
    CAFE: { color: '#D97706', dark: '#92400E' },
    CREDIT: { color: '#EF4444', dark: '#B91C1C' },
    VOUCHER: { color: '#EC4899', dark: '#BE185D' },
    OWNLY: { color: '#14B8A6', dark: '#0F766E' },
    NEFT: { color: '#64748B', dark: '#334155' },
    CHEQUE: { color: '#78716C', dark: '#44403C' },
    SWIGGY: { color: '#F97316', dark: '#C2410C' },
    ZOMATO: { color: '#DC2626', dark: '#991B1B' },
    SWIGGYSTORE: { color: '#EA580C', dark: '#9A3412' },
    URBAN: { color: '#7C3AED', dark: '#5B21B6' },
    DUNZO: { color: '#059669', dark: '#065F46' },
    AMAZON: { color: '#F59E0B', dark: '#92400E' }
};

/* ── Derive active payment methods from settings JSON ── */
const PAY_METHODS = APP_SETTINGS.Details.filter((d) => d.setting_type === 'Payment' && d.setting_access === '1' && d.status === 'Active').map((d) => ({
    id: d.setting_name,
    label: d.setting_title,
    ...(PAY_COLOR_MAP[d.setting_name] || { color: '#64748B', dark: '#334155' })
}));

const SIDE_BTNS = [
    { icon: '📋', label: 'Orders' },
    { icon: '⚡', label: 'Quick' },
    { icon: '🔄', label: 'Refresh' },
    { icon: '🖨️', label: 'Print' }
];

/* ── CSS ── */
if (!document.getElementById('pos-gs-v4')) {
    const s = document.createElement('style');
    s.id = 'pos-gs-v4';
    s.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
    @keyframes slideDown { from{opacity:0;transform:translateY(-8px)} to{opacity:1;transform:translateY(0)} }
    @keyframes fadeIn    { from{opacity:0} to{opacity:1} }
    @keyframes popIn     { 0%{transform:scale(0.65);opacity:0} 70%{transform:scale(1.07)} 100%{transform:scale(1);opacity:1} }
    @keyframes ripple    { 0%{transform:scale(0);opacity:0.45} 100%{transform:scale(4.5);opacity:0} }
    @keyframes rowIn     { from{opacity:0;transform:translateX(14px)} to{opacity:1;transform:translateX(0)} }
    @keyframes bounce    { 0%,100%{transform:translateY(0)} 40%{transform:translateY(-5px)} 60%{transform:translateY(-2px)} }
    *{box-sizing:border-box}
    ::-webkit-scrollbar{width:3px;height:3px}
    ::-webkit-scrollbar-track{background:rgba(124,58,237,0.05);border-radius:99px}
    ::-webkit-scrollbar-thumb{background:rgba(124,58,237,0.28);border-radius:99px}
    ::-webkit-scrollbar-thumb:hover{background:rgba(124,58,237,0.5)}
  `;
    document.head.appendChild(s);
}

/* ── Ripple ── */
function RippleBtn({ children, onClick, style, onMouseEnter, onMouseLeave }) {
    const ref = useRef(null);
    function go(e) {
        const btn = ref.current,
            sp = document.createElement('span');
        const r = btn.getBoundingClientRect(),
            sz = Math.max(r.width, r.height);
        sp.style.cssText = `position:absolute;width:${sz}px;height:${sz}px;border-radius:50%;
      background:rgba(255,255,255,0.3);pointer-events:none;
      left:${e.clientX - r.left - sz / 2}px;top:${e.clientY - r.top - sz / 2}px;
      transform:scale(0);animation:ripple 0.5s ease-out forwards;`;
        btn.appendChild(sp);
        setTimeout(() => sp.remove(), 520);
        onClick && onClick(e);
    }
    return (
        <button ref={ref} onClick={go} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} style={{ position: 'relative', overflow: 'hidden', cursor: 'pointer', border: 'none', ...style }}>
            {children}
        </button>
    );
}

/* ── Toast ── */
function Toast({ msg, onDone }) {
    useEffect(() => {
        const t = setTimeout(onDone, 2200);
        return () => clearTimeout(t);
    }, []);
    return (
        <div
            style={{
                position: 'fixed',
                bottom: 52,
                left: '50%',
                transform: 'translateX(-50%)',
                background: P.purpleDark,
                color: '#fff',
                fontFamily: 'Inter,sans-serif',
                fontWeight: 700,
                fontSize: 13,
                padding: '10px 24px',
                borderRadius: 50,
                zIndex: 9999,
                boxShadow: `0 6px 24px rgba(109,40,217,0.45)`,
                animation: 'popIn 0.3s ease both',
                display: 'flex',
                alignItems: 'center',
                gap: 8
            }}
        >
            ✅ {msg}
        </div>
    );
}

/* ════ MAIN ════ */
export default function POSDashboard() {
    const [clock, setClock] = useState(new Date());
    const [activeCat, setActiveCat] = useState(null);
    const [cart, setCart] = useState([]);
    const [flashId, setFlashId] = useState(null);
    const [toast, setToast] = useState(null);
    const [paying, setPaying] = useState(null);
    const [gridKey, setGridKey] = useState(0);
    const [categories, setCategories] = useState([]);
    const [catLoading, setCatLoading] = useState(true);
    const [allProducts, setAllProducts] = useState([]);
    const [prodLoading, setProdLoading] = useState(true);
    const ff = 'Inter,-apple-system,sans-serif';

    useEffect(() => {
        const t = setInterval(() => setClock(new Date()), 1000);
        return () => clearInterval(t);
    }, []);

    /* fetch categories — pr_cat_name = display, pr_cat_code = key */
    useEffect(() => {
        fetch('https://treatway.co.in/Counter-Backend/api/live_data/Get_product_category/SB2', { method: 'POST' })
            .then((r) => r.json())
            .then((d) => {
                const raw = Array.isArray(d) ? d : d.data || d.Details || d.categories || [];
                console.log('[CAT] first item:', raw[0]);
                const list = raw.map((c) => ({
                    id: String(c.pr_cat_code),
                    label: c.pr_cat_name
                }));
                setCategories(list);
                if (list.length) setActiveCat(list[0].id);
            })
            .catch((e) => console.error('[CAT] fetch error', e))
            .finally(() => setCatLoading(false));
    }, []);

    /* fetch all products once — filter by pr_cat_code per category */
    useEffect(() => {
        fetch('https://treatway.co.in/Counter-Backend/api/live_data/Get_product/SB2', { method: 'POST' })
            .then((r) => r.json())
            .then((d) => {
                const raw = Array.isArray(d) ? d : d.data || d.Details || d.products || [];
                console.log('[PROD] first item:', raw[0]);
                setAllProducts(
                    raw.map((p) => ({
                        id: p.pr_code ?? p.id,
                        name: p.pr_name ?? p.name,
                        price: Number(p.pr_rate ?? p.pr_sell_price ?? p.price ?? 0),
                        tax: Number(p.pr_tax ?? p.pr_gst ?? p.tax ?? 0),
                        catCode: String(p.pr_cat_code)
                    }))
                );
            })
            .catch((e) => console.error('[PROD] fetch error', e))
            .finally(() => setProdLoading(false));
    }, []);

    const products = allProducts.filter((p) => p.catCode === activeCat);

    function switchCat(id) {
        if (id === activeCat) return;
        setActiveCat(id);
        setGridKey((k) => k + 1);
    }

    function addToCart(p) {
        setFlashId(p.id);
        setTimeout(() => setFlashId(null), 280);
        setCart((prev) => {
            const ex = prev.find((i) => i.id === p.id);
            if (ex) return prev.map((i) => (i.id === p.id ? { ...i, qty: i.qty + 1 } : i));
            return [...prev, { ...p, qty: 1, addedAt: Date.now() }];
        });
    }

    function removeQty(id) {
        setCart((prev) => {
            const item = prev.find((i) => i.id === id);
            if (!item) return prev;
            if (item.qty === 1) return prev.filter((i) => i.id !== id);
            return prev.map((i) => (i.id === id ? { ...i, qty: i.qty - 1 } : i));
        });
    }

    function clearCart() {
        setCart([]);
        setPaying(null);
    }

    function handlePay(m) {
        if (!cart.length) return;
        setPaying(m.id);
        setTimeout(() => {
            setToast(`₹${billTotal} paid via ${m.id}`);
            clearCart();
        }, 360);
    }

    const totalQty = cart.reduce((s, i) => s + i.qty, 0);
    const totalPrice = cart.reduce((s, i) => s + i.price * i.qty, 0);
    const taxAmount = cart.reduce((s, i) => s + Math.round((i.price * i.qty * i.tax) / 100), 0);
    const billTotal = totalPrice + taxAmount;

    const timeStr = clock.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true });
    const dateStr = clock.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '-');
    const curCat = categories.find((c) => c.id === activeCat);

    function tileStyle(active, selected, idx, delay = 0.022) {
        return {
            background: active ? `linear-gradient(135deg,${P.purple},${P.purpleDeep})` : selected ? P.purpleLight : P.surface,
            border: active ? `2px solid ${P.purpleDeep}` : selected ? `1.5px solid ${P.purple}` : `1.5px solid ${P.border}`,
            borderRadius: 8,
            padding: '6px 5px 7px',
            textAlign: 'center',
            fontSize: 10,
            fontWeight: 700,
            color: active ? '#fff' : selected ? P.purpleDark : P.text,
            lineHeight: 1.35,
            minHeight: 58,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            transition: 'transform 0.14s,box-shadow 0.16s,border-color 0.14s,background 0.14s',
            boxShadow: active ? `0 4px 14px rgba(124,58,237,0.45)` : selected ? `0 2px 8px rgba(124,58,237,0.15)` : '0 1px 3px rgba(0,0,0,0.05)',
            transform: active ? 'scale(0.95)' : 'scale(1)',
            fontFamily: ff,
            animation: `slideDown 0.24s ${Math.min(idx, 11) * delay}s both`
        };
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100vh', minHeight: 580, background: P.bg, fontFamily: ff, overflow: 'hidden' }}>
            {/* ══ TOP BAR ══ */}
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    background: `linear-gradient(135deg,${P.purpleMid} 0%,${P.purple} 50%,${P.purpleDeep} 100%)`,
                    padding: '0 14px',
                    height: 52,
                    flexShrink: 0,
                    boxShadow: `0 3px 16px rgba(109,40,217,0.4)`,
                    zIndex: 10
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{ width: 32, height: 32, borderRadius: 8, background: 'rgba(255,255,255,0.2)', border: '1.5px solid rgba(255,255,255,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16 }}>◀</div>
                    <span style={{ fontSize: 17, fontWeight: 900, color: '#fff', letterSpacing: 0.3, fontFamily: ff }}>GravitySoft</span>
                    <div style={{ width: 1, height: 22, background: 'rgba(255,255,255,0.25)', margin: '0 4px' }} />
                    <div style={{ display: 'flex', gap: 4 }}>
                        {['▲', '▼'].map((a) => (
                            <button
                                key={a}
                                style={{
                                    width: 27,
                                    height: 27,
                                    borderRadius: '50%',
                                    background: 'rgba(255,255,255,0.15)',
                                    border: '1.5px solid rgba(255,255,255,0.3)',
                                    color: '#fff',
                                    fontSize: 12,
                                    cursor: 'pointer',
                                    fontWeight: 900,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'background 0.18s'
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(255,255,255,0.28)')}
                                onMouseLeave={(e) => (e.currentTarget.style.background = 'rgba(255,255,255,0.15)')}
                            >
                                {a}
                            </button>
                        ))}
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', background: 'rgba(0,0,0,0.12)', border: '1px solid rgba(255,255,255,0.18)', borderRadius: 10, padding: '3px 18px' }}>
                    <span style={{ fontSize: 16, fontWeight: 800, color: '#fff', letterSpacing: 0.3 }}>SB1 · {dateStr}</span>
                    <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.85)', fontWeight: 600, letterSpacing: 1.8 }}>{timeStr}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span style={{ fontSize: 13, fontWeight: 700, color: '#fff', fontFamily: ff }}>Welcome, GSMASTER</span>
                    <div style={{ width: 32, height: 32, borderRadius: '50%', background: 'rgba(255,255,255,0.2)', border: '2px solid rgba(255,255,255,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15 }}>👤</div>
                    <RippleBtn
                        onClick={clearCart}
                        style={{
                            background: 'rgba(239,68,68,0.85)',
                            border: '1.5px solid rgba(255,255,255,0.25)',
                            borderRadius: 9,
                            color: '#fff',
                            fontWeight: 800,
                            fontSize: 12,
                            padding: '6px 14px',
                            fontFamily: ff,
                            boxShadow: '0 3px 10px rgba(185,28,28,0.35)',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 5
                        }}
                    >
                        ⚠️ LOGOUT
                    </RippleBtn>
                </div>
            </div>

            {/* ══ MAIN ══ */}
            <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
                {/* ── LEFT: product grid ── */}
                <div style={{ flex: '0 0 52%', display: 'flex', flexDirection: 'column', borderRight: `1px solid ${P.border}`, background: P.bg, overflow: 'hidden' }}>
                    <div style={{ padding: '6px 8px 4px', borderBottom: `1px solid ${P.border}`, background: P.surface, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
                        <span style={{ fontSize: 11, fontWeight: 800, color: P.purple, letterSpacing: 0.5, fontFamily: ff }}>{curCat?.label} — ITEMS</span>
                        <span style={{ fontSize: 10, color: P.muted, fontFamily: ff }}>{prodLoading ? 'Loading…' : `${products.length} products`}</span>
                    </div>
                    <div
                        key={gridKey}
                        style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(4,1fr)',
                            gap: 4,
                            padding: 5,
                            flex: 1,
                            overflowY: 'auto',
                            alignContent: 'start'
                        }}
                    >
                        {prodLoading ? (
                            <div style={{ gridColumn: '1/-1', display: 'flex', alignItems: 'center', justifyContent: 'center', height: 120, color: P.muted, fontSize: 12, fontFamily: ff }}>Loading products…</div>
                        ) : (
                            products.map((p, idx) => {
                                const active = flashId === p.id;
                                const inCart = cart.find((c) => c.id === p.id);
                                return (
                                    <RippleBtn
                                        key={p.id}
                                        onClick={() => addToCart(p)}
                                        style={tileStyle(active, !!inCart, idx)}
                                        onMouseEnter={(e) => {
                                            if (!active) {
                                                e.currentTarget.style.transform = 'scale(1.04)';
                                                e.currentTarget.style.boxShadow = `0 4px 14px rgba(124,58,237,0.2)`;
                                                e.currentTarget.style.borderColor = P.purple;
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!active) {
                                                e.currentTarget.style.transform = 'scale(1)';
                                                e.currentTarget.style.boxShadow = inCart ? `0 2px 8px rgba(124,58,237,0.15)` : '0 1px 3px rgba(0,0,0,0.05)';
                                                e.currentTarget.style.borderColor = inCart ? P.purple : P.border;
                                            }
                                        }}
                                    >
                                        <span style={{ fontSize: 10, fontWeight: 700, lineHeight: 1.4, whiteSpace: 'normal', wordBreak: 'break-word', padding: '0 2px' }}>{p.name}</span>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5, marginTop: 3 }}>
                                            <span style={{ width: 7, height: 7, borderRadius: '50%', background: P.success, flexShrink: 0, boxShadow: `0 0 4px rgba(34,197,94,0.5)` }} />
                                            {inCart && (
                                                <span
                                                    style={{
                                                        fontSize: 9,
                                                        fontWeight: 800,
                                                        color: active ? '#fff' : P.purple,
                                                        background: active ? 'rgba(255,255,255,0.25)' : P.purpleLight,
                                                        padding: '1px 5px',
                                                        borderRadius: 99,
                                                        animation: 'popIn 0.2s ease both'
                                                    }}
                                                >
                                                    ×{inCart.qty}
                                                </span>
                                            )}
                                        </div>
                                    </RippleBtn>
                                );
                            })
                        )}
                    </div>
                </div>

                {/* ── RIGHT ── */}
                <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', background: P.surface }}>
                        {/* cart header */}
                        <div style={{ padding: '6px 8px 4px', borderBottom: `1px solid ${P.border}`, background: P.surface, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
                            <span style={{ fontSize: 11, fontWeight: 800, color: P.purple, letterSpacing: 0.5, fontFamily: ff }}>CART</span>
                            {cart.length > 0 && (
                                <RippleBtn onClick={clearCart} style={{ background: P.danger, color: '#fff', borderRadius: 6, padding: '2px 9px', fontSize: 10, fontWeight: 700, fontFamily: ff }}>
                                    ✕ Clear
                                </RippleBtn>
                            )}
                        </div>

                        {/* cart body */}
                        <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', padding: '6px 6px 0' }}>
                            {cart.length === 0 ? (
                                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 8, animation: 'fadeIn 0.4s' }}>
                                    <div style={{ animation: 'bounce 2.2s infinite' }}>
                                        <svg width="96" height="84" viewBox="0 0 96 84">
                                            <line x1="8" y1="8" x2="18" y2="34" stroke={P.border} strokeWidth="3" strokeLinecap="round" />
                                            <rect x="18" y="24" width="64" height="42" rx="6" fill="none" stroke={P.border} strokeWidth="2.5" />
                                            {[0, 1, 2, 3, 4].map((i) => (
                                                <line key={i} x1={24 + i * 11} y1="24" x2={24 + i * 11} y2="66" stroke={P.borderLight} strokeWidth="1" />
                                            ))}
                                            {[0, 1, 2, 3].map((i) => (
                                                <line key={i} x1="18" y1={33 + i * 9} x2="82" y2={33 + i * 9} stroke={P.borderLight} strokeWidth="1" />
                                            ))}
                                            <rect x="18" y="24" width="64" height="8" rx="4" fill={P.purple} />
                                            <circle cx="31" cy="74" r="6" fill={P.purpleLight} stroke={P.purple} strokeWidth="1.5" />
                                            <circle cx="31" cy="74" r="2.5" fill={P.surface} />
                                            <circle cx="70" cy="74" r="6" fill={P.purpleLight} stroke={P.purple} strokeWidth="1.5" />
                                            <circle cx="70" cy="74" r="2.5" fill={P.surface} />
                                            <rect x="3" y="4" width="11" height="7" rx="3" fill={P.purpleLight} stroke={P.border} strokeWidth="1.2" />
                                        </svg>
                                    </div>
                                    <p style={{ color: P.muted, fontSize: 12, fontWeight: 600, fontFamily: ff, margin: 0 }}>Cart is empty</p>
                                    <p style={{ color: P.border, fontSize: 10, fontFamily: ff, margin: 0 }}>Tap a product to add</p>
                                </div>
                            ) : (
                                <>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 5, paddingBottom: 5, borderBottom: `1px solid ${P.borderLight}` }}>
                                        <span style={{ background: P.purple, color: '#fff', borderRadius: 99, fontWeight: 800, fontSize: 10, padding: '2px 8px', fontFamily: ff, animation: 'popIn 0.2s ease both' }}>{totalQty}</span>
                                        <span style={{ fontSize: 11, fontWeight: 700, color: P.purple, fontFamily: ff }}>items in cart</span>
                                    </div>
                                    <div style={{ flex: 1, overflowY: 'auto' }}>
                                        <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 2px', fontSize: 11, fontFamily: ff }}>
                                            <thead>
                                                <tr>
                                                    {['#', 'Product', 'Qty', 'Price', 'Tax', 'Total'].map((h, i) => (
                                                        <th
                                                            key={h}
                                                            style={{
                                                                padding: '6px 6px',
                                                                textAlign: i === 1 ? 'left' : 'center',
                                                                fontSize: 9,
                                                                fontWeight: 800,
                                                                color: '#fff',
                                                                letterSpacing: '0.05em',
                                                                background: P.purple,
                                                                borderRadius: i === 0 ? '6px 0 0 6px' : i === 5 ? '0 6px 6px 0' : 0,
                                                                position: 'sticky',
                                                                top: 0,
                                                                zIndex: 2
                                                            }}
                                                        >
                                                            {h}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {cart.map((item, idx) => (
                                                    <tr key={item.id} style={{ animation: Date.now() - (item.addedAt || 0) < 600 ? 'rowIn 0.25s ease both' : 'none' }}>
                                                        <td
                                                            style={{
                                                                padding: '5px 6px',
                                                                textAlign: 'center',
                                                                color: P.muted,
                                                                fontWeight: 700,
                                                                borderRadius: '6px 0 0 6px',
                                                                background: idx % 2 === 0 ? P.surface : '#FAFAFA',
                                                                border: `1px solid ${P.borderLight}`,
                                                                borderRight: 'none'
                                                            }}
                                                        >
                                                            {idx + 1}
                                                        </td>
                                                        <td
                                                            style={{
                                                                padding: '5px 6px',
                                                                textAlign: 'left',
                                                                fontWeight: 700,
                                                                color: P.text,
                                                                background: idx % 2 === 0 ? P.surface : '#FAFAFA',
                                                                border: `1px solid ${P.borderLight}`,
                                                                borderLeft: 'none',
                                                                borderRight: 'none',
                                                                maxWidth: 90,
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap'
                                                            }}
                                                        >
                                                            {item.name}
                                                        </td>
                                                        <td style={{ padding: '5px 6px', textAlign: 'center', background: idx % 2 === 0 ? P.surface : '#FAFAFA', border: `1px solid ${P.borderLight}`, borderLeft: 'none', borderRight: 'none' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3 }}>
                                                                <button
                                                                    onClick={() => removeQty(item.id)}
                                                                    style={{
                                                                        width: 18,
                                                                        height: 18,
                                                                        borderRadius: 4,
                                                                        background: '#FEF2F2',
                                                                        border: '1px solid #FECACA',
                                                                        color: P.danger,
                                                                        cursor: 'pointer',
                                                                        fontSize: 12,
                                                                        fontWeight: 900,
                                                                        lineHeight: 1,
                                                                        padding: 0,
                                                                        transition: 'all 0.15s'
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        e.currentTarget.style.background = P.danger;
                                                                        e.currentTarget.style.color = '#fff';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.currentTarget.style.background = '#FEF2F2';
                                                                        e.currentTarget.style.color = P.danger;
                                                                    }}
                                                                >
                                                                    −
                                                                </button>
                                                                <span style={{ fontWeight: 800, minWidth: 16, textAlign: 'center', color: P.purple, fontSize: 12 }}>{item.qty}</span>
                                                                <button
                                                                    onClick={() => addToCart(item)}
                                                                    style={{
                                                                        width: 18,
                                                                        height: 18,
                                                                        borderRadius: 4,
                                                                        background: P.purple,
                                                                        border: 'none',
                                                                        color: '#fff',
                                                                        cursor: 'pointer',
                                                                        fontSize: 12,
                                                                        fontWeight: 900,
                                                                        lineHeight: 1,
                                                                        padding: 0,
                                                                        transition: 'transform 0.15s'
                                                                    }}
                                                                    onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.15)')}
                                                                    onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                                >
                                                                    +
                                                                </button>
                                                            </div>
                                                        </td>
                                                        <td
                                                            style={{
                                                                padding: '5px 6px',
                                                                textAlign: 'center',
                                                                color: P.textLight,
                                                                background: idx % 2 === 0 ? P.surface : '#FAFAFA',
                                                                border: `1px solid ${P.borderLight}`,
                                                                borderLeft: 'none',
                                                                borderRight: 'none'
                                                            }}
                                                        >
                                                            ₹{item.price}
                                                        </td>
                                                        <td
                                                            style={{
                                                                padding: '5px 6px',
                                                                textAlign: 'center',
                                                                color: P.warning,
                                                                fontWeight: 700,
                                                                background: idx % 2 === 0 ? P.surface : '#FAFAFA',
                                                                border: `1px solid ${P.borderLight}`,
                                                                borderLeft: 'none',
                                                                borderRight: 'none'
                                                            }}
                                                        >
                                                            ₹{Math.round((item.price * item.qty * item.tax) / 100)}
                                                        </td>
                                                        <td
                                                            style={{
                                                                padding: '5px 6px',
                                                                textAlign: 'center',
                                                                fontWeight: 800,
                                                                color: P.purpleDeep,
                                                                borderRadius: '0 6px 6px 0',
                                                                background: idx % 2 === 0 ? P.surface : '#FAFAFA',
                                                                border: `1px solid ${P.borderLight}`,
                                                                borderLeft: 'none'
                                                            }}
                                                        >
                                                            ₹{item.price * item.qty + Math.round((item.price * item.qty * item.tax) / 100)}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )}
                        </div>

                        {/* billing summary */}
                        <div style={{ display: 'flex', flexShrink: 0, borderTop: `1px solid ${P.border}`, background: P.bg }}>
                            {[
                                { label: 'Total Price', value: `₹${totalPrice}`, hi: false },
                                { label: 'Tax Amount', value: `₹${taxAmount}`, hi: false },
                                { label: 'Total Qty', value: totalQty, hi: false },
                                { label: 'Bill Total', value: `₹${billTotal}`, hi: true }
                            ].map((cell, i) => (
                                <div key={cell.label} style={{ flex: 1, textAlign: 'center', padding: '7px 3px', borderRight: i < 3 ? `1px solid ${P.border}` : 'none', background: cell.hi ? P.purpleLight : 'transparent' }}>
                                    <div style={{ fontSize: 8.5, fontWeight: 700, color: P.muted, marginBottom: 2, textTransform: 'uppercase', letterSpacing: '0.07em', fontFamily: ff }}>{cell.label}</div>
                                    <div style={{ fontSize: cell.hi ? 19 : 16, fontWeight: 900, color: cell.hi ? P.purpleDeep : P.text, fontFamily: ff }}>{cell.value || 0}</div>
                                </div>
                            ))}
                        </div>

                        {/* payment methods */}
                        <div style={{ flexShrink: 0, borderTop: `1px solid ${P.border}`, background: P.purpleLight }}>
                            <div style={{ padding: '3px 6px 2px', borderBottom: `1px solid ${P.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <span style={{ fontSize: 9, fontWeight: 800, color: P.purple, letterSpacing: '0.08em', textTransform: 'uppercase', fontFamily: ff }}>Payment Mode</span>
                                <span style={{ fontSize: 9, color: P.muted, fontFamily: ff }}>{PAY_METHODS.length} methods active</span>
                            </div>
                            <div style={{ display: 'flex', gap: 3, padding: '4px 5px', flexWrap: 'nowrap', overflowX: 'auto' }}>
                                {PAY_METHODS.map((m) => (
                                    <RippleBtn
                                        key={m.id}
                                        onClick={() => handlePay(m)}
                                        style={{
                                            flex: '1 1 0',
                                            minWidth: 0,
                                            padding: '8px 2px',
                                            background: paying === m.id ? m.dark : m.color,
                                            color: '#fff',
                                            fontWeight: 800,
                                            fontSize: PAY_METHODS.length > 6 ? 10 : 12,
                                            borderRadius: 8,
                                            fontFamily: ff,
                                            boxShadow: cart.length ? `0 3px 10px ${m.color}44` : 'none',
                                            opacity: cart.length ? 1 : 0.45,
                                            transition: 'all 0.18s',
                                            transform: paying === m.id ? 'scale(0.95)' : 'scale(1)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: 1,
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (cart.length) {
                                                e.currentTarget.style.transform = 'scale(1.05)';
                                                e.currentTarget.style.background = m.dark;
                                                e.currentTarget.style.boxShadow = `0 5px 16px ${m.color}66`;
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (paying !== m.id) {
                                                e.currentTarget.style.transform = 'scale(1)';
                                                e.currentTarget.style.background = m.color;
                                                e.currentTarget.style.boxShadow = cart.length ? `0 3px 10px ${m.color}44` : 'none';
                                            }
                                        }}
                                    >
                                        {m.label}
                                    </RippleBtn>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* sidebar */}
                    <div style={{ width: 54, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, padding: '8px 4px', background: P.bg, borderLeft: `1px solid ${P.border}` }}>
                        {SIDE_BTNS.map((b, i) => (
                            <button
                                key={b.label}
                                title={b.label}
                                style={{
                                    width: 42,
                                    height: 42,
                                    borderRadius: 9,
                                    background: P.surface,
                                    border: `1px solid ${P.border}`,
                                    cursor: 'pointer',
                                    fontSize: 16,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
                                    transition: 'all 0.18s',
                                    gap: 1,
                                    fontFamily: ff,
                                    animation: `slideDown 0.28s ${i * 0.07}s both`
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.background = P.purpleLight;
                                    e.currentTarget.style.borderColor = P.purple;
                                    e.currentTarget.style.boxShadow = `0 3px 10px rgba(124,58,237,0.18)`;
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.background = P.surface;
                                    e.currentTarget.style.borderColor = P.border;
                                    e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.05)';
                                }}
                            >
                                <span>{b.icon}</span>
                                <span style={{ fontSize: 7, fontWeight: 700, color: P.muted, fontFamily: ff }}>{b.label}</span>
                            </button>
                        ))}
                        {cart.length > 0 && (
                            <div
                                style={{
                                    marginTop: 'auto',
                                    width: 42,
                                    height: 42,
                                    borderRadius: 9,
                                    background: P.purple,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: `0 3px 12px rgba(124,58,237,0.45)`,
                                    animation: 'popIn 0.3s ease both'
                                }}
                            >
                                <span style={{ fontSize: 16, fontWeight: 900, color: '#fff', fontFamily: ff }}>{totalQty}</span>
                                <span style={{ fontSize: 7, fontWeight: 700, color: 'rgba(255,255,255,0.8)', fontFamily: ff }}>ITEMS</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* ══ CATEGORY GRID — 6 columns, equal width & height ══ */}
            <div style={{ flexShrink: 0, borderTop: `1px solid ${P.border}`, background: P.surface, overflowY: 'auto', maxHeight: 200 }}>
                {catLoading ? (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 60, color: P.muted, fontSize: 11, fontFamily: ff }}>Loading categories…</div>
                ) : (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6,1fr)', gap: 0 }}>
                        {categories.map((cat) => {
                            const sel = activeCat === cat.id;
                            return (
                                <RippleBtn
                                    key={cat.id}
                                    onClick={() => switchCat(cat.id)}
                                    style={{
                                        height: 52,
                                        background: sel ? `linear-gradient(135deg,${P.purple},${P.purpleDeep})` : P.surface,
                                        border: 'none',
                                        borderRight: `1px solid ${P.borderLight}`,
                                        borderBottom: `1px solid ${P.borderLight}`,
                                        textAlign: 'center',
                                        fontSize: 9.5,
                                        fontWeight: 700,
                                        color: sel ? '#fff' : P.text,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '0 4px',
                                        lineHeight: 1.3,
                                        transition: 'background 0.13s,color 0.13s',
                                        fontFamily: ff,
                                        boxShadow: sel ? `inset 0 -3px 0 ${P.purpleDeep}` : 'none'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!sel) {
                                            e.currentTarget.style.background = P.purpleLight;
                                            e.currentTarget.style.color = P.purpleDark;
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!sel) {
                                            e.currentTarget.style.background = P.surface;
                                            e.currentTarget.style.color = P.text;
                                        }
                                    }}
                                >
                                    {cat.label}
                                </RippleBtn>
                            );
                        })}
                    </div>
                )}
            </div>

            {toast && <Toast msg={toast} onDone={() => setToast(null)} />}
        </div>
    );
}
